import React, { useState } from "react";
import {Dialog} from 'primereact/dialog';
import GenericUI from "../generic.ui";
import {Translator} from "../../translator";
import {AuthenticationAPI} from "../../../api/authentication";

//import "./styles/smartphone.css";
//import "./styles/tablet.css";
import "./styles/desktop.css";

function changeEmail(e)
{
    window.AuthenticationPanel.setState( { email: e.target.value } );
}

function changePassword(e)
{
    window.AuthenticationPanel.setState({password: e.target.value } );
}

function togglePasswordVisibility()
{
    window.AuthenticationPanel.setState(prevState => ({
        showPassword: !prevState.showPassword
    }));
}

function loginUser()
{
    AuthenticationAPI.authLogin()
        .then((response) => {
            if( response )
            {
                window.open('index.html', '_self');
            }
        })
        .catch( (error ) => {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', error );
            }

        });
}

export default class AuthenticationPanel extends GenericUI
{
    constructor( props ) {
        super( props );
        this.state = {
            email: ( props.user && props.user.email ) ? props.user.email : '',
            password: ( props.user && props.user.password ) ? props.user.password : '',
            context: props.context,
            user: props.user,
            token: props.token,
            visible: ( props.context === 'authentication' ) ? true : false,
            restart: false,
            showPassword: false,
            rememberMe: false
        };
    }

    componentDidMount()
    {
        window.AuthenticationPanel = this;
    }

    hide()
    {
        if( this.state.restart )
        {
            window.open('index.html', '_self');
        }
        this.setState( { visible: false, restart: false } );
    }
    
    handleKeyDown(e) {
        if( e.key === "Escape" )
        {
            this.hide();
        }

        if( e.key === "Enter" )
        {
            loginUser();
        }
    }

    showRegister(e) {
        this.setState( { visible: false, restart: false } );
        if( window.RegisterPanel )
        {
            window.RegisterPanel.setState( {
                visible: true
            } );
        }
    }

    render()
    {
        super.render();

        if( this.state.visible )
        {
            return(
                <div className="mask">
                    <Dialog
                        modal
                        visible={this.state.visible}
                        onHide={() => this.hide() }
                        header={Translator.get("authentication")}
                        className="auth-panel"
                        closable={false}
                        footer={
                            <div className="auth-buttons">
								<div className="forgot-password">
                            		<a href="https://account.aoz.studio/app/ITRocks/Framework/User/Password/reset" target="new" className="no-text-select">{Translator.get("forgot_password")}</a>
								</div>
                            	<button onClick={( e ) => { this.showRegister(e) }} className="btn-create" id="auth-btn-register">{Translator.get("create_an_account")}</button>
                            	<button onClick={loginUser} id="auth-btn-click" className="btn-special">{Translator.get("login")}</button>
                            </div>
                        }
                    >

                        <div className="auth-email-field">
                            <label htmlFor="fld_email">{Translator.get("email")}</label>
                            <input onKeyDown={ ( e ) => { this.handleKeyDown(e) } } type="email" autoComplete="email" id="fld_email" name="fld_email" placeholder={Translator.get('enter_your_email')} defaultValue={ this.state.email } onChange={ changeEmail } />
                        </div>

                        <div className="auth-password-field">
                            <label htmlFor="fld_password">{Translator.get("password")}</label>
                            <div className="password-input-container">
                                <input 
                                    onKeyDown={ ( e ) => { this.handleKeyDown(e) } } 
                                    type={this.state.showPassword ? "text" : "password"} 
                                    autoComplete="current-password" 
                                    id="fld_password" 
                                    name="fld_password" 
                                    placeholder={Translator.get('enter_your_password')} 
                                    defaultValue={ this.state.password } 
                                    onChange={ changePassword } 
                                />
                                <button 
                                    type="button" 
                                    className="password-toggle" 
                                    onClick={togglePasswordVisibility}
                                    aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                                >
                                    <i className={`fa ${this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </button>
                            </div>
                        </div>

                        <div className="auth-remember-field">
                            <input 
                                type="checkbox" 
                                id="remember" 
                                name="remember"
                                checked={this.state.rememberMe}
                                onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                            />
                            <label htmlFor="remember">{Translator.get("remember_me")}</label>
                        </div>


                        
                    </Dialog>
                </div>
            );
        }
        else
        {
            return null;
        
        }
    }
}

/*

<div className="auth-buttons">
                            <a href="#" className="forgot-password no-text-select">{Translator.get("forgot_password")}</a>
                            <button onClick={( e ) => { this.showRegister(e) }} className="btn-create" id="auth-btn-register">{Translator.get("create_an_account")}</button>
                            <button onClick={loginUser} id="auth-btn-click" className="btn-special">{Translator.get("login")}</button>
                        </div>
*/